<template lang="pug">
  div.view-z.flex-row.align-items-center
    div.container
      div.row.justify-content-center
        div.col-md-6
          b-card.shadow-lg.rounded.theme-glass
            div.p-3
              div.d-flex.flex-row.align-items-baseline
                h1 {{ $t("ui.affiliate_signup") }}
              b-form.signup-form(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
                div.row
                  div.col-md-6
                    b-form-group(:label="$t('ui.username') + ' *'")
                      DebounceInput(
                        required
                        ref="account_id"
                        type="text"
                        v-model.trim.lazy="$v.account_id.$model"
                        :disabled="loading"
                        :maxLength="$v.account_id.$params.maxLength.max"
                        :dirty="$v.account_id.$dirty"
                        :error="$v.account_id.$error"
                      )
                      span.small(style="color: yellow;") This is ID for login, e.g. Jacky
                      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
                  div.col-md-6
                    b-form-group(:label="$t('ui.affiliate_code') + ' *'")
                      DebounceInput(
                        required
                        type="text"
                        v-model.trim.lazy="$v.affiliate_code.$model"
                        :disabled="loading"
                        :dirty="$v.affiliate_code.$dirty"
                        :error="$v.affiliate_code.$error"
                      )
                      span.small(style="color: yellow;") This is code refer to friend, e.g. KEYMAN
                      ValidateResult(:value="$v.affiliate_code" :name="$t('ui.affiliate_code')")
                div.row
                  div.col-md-6
                    b-form-group(:label="$t('ui.password') + ' *'")
                      DebounceInput(
                        required
                        type="password"
                        v-model.trim.lazy="$v.password.$model"
                        :disabled="loading"
                        :maxLength="$v.password.$params.maxLength.max"
                        :dirty="$v.password.$dirty"
                        :error="$v.password.$error"
                      )
                      ValidateResult(:value="$v.password" :name="$t('ui.password')")
                  div.col-md-6
                    b-form-group(:label="$t('ui.confirm_password') + ' *'")
                      DebounceInput(
                        required
                        type="password"
                        v-model.trim.lazy="$v.confirm_password.$model"
                        :disabled="loading"
                        :dirty="$v.confirm_password.$dirty"
                        :error="$v.confirm_password.$error"
                      )
                      ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')" :name2="$t('ui.password')")
                div.row
                  div.col-md-12
                    b-form-group(:label="$t('ui.contact_phone') + ' *'")
                      DebounceInput(
                        required
                        type="text"
                        v-model.trim.lazy="$v.contact_phone.$model"
                        :disabled="loading"
                        :dirty="$v.contact_phone.$dirty"
                        :error="$v.contact_phone.$error"
                      )
                      span.small(style="color: yellow;") e.g. 0123456789, you will receive SMS upon application approval
                      ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
                  //- div.col-md-6
                  //-   b-form-group(:label="$t('ui.currency')")
                  //-     CurrencyLookup(
                  //-       size="sm"
                  //-       required
                  //-       type="array"
                  //-       :dirty="$v.currency_code.$dirty"
                  //-       :error="$v.currency_code.$error"
                  //-       v-model.trim.lazy="$v.currency_code.$model"
                  //-       :disabled="loading"
                  //-     )
                  //-     ValidateResult(:value="$v.currency_code" :name="$t('ui.currency')")
                div.row
                 div.col-md-12
                    b-form-group(:label="$t('ui.optional_fields')")
                      div.d-flex
                        label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                          input.switch-input(
                            type="checkbox"
                            required
                            v-model="optional"
                            :disabled="loading"
                          )
                          span.switch-slider
                div.row
                  div.col-md-6
                    b-form-group(:label="$t('ui.contact_email')" v-if="optional")
                      DebounceInput(
                        type="text"
                        v-model.trim.lazy="$v.contact_email.$model"
                        :disabled="loading"
                        :dirty="$v.contact_email.$dirty"
                        :error="$v.contact_email.$error"
                      )
                      ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
                  div.col-md-6
                    b-form-group(:label="$t('ui.dob')" v-if="optional")
                      b-input-group(size="sm")
                        date-picker(v-model="dob" :config="locale")
                b-form-group(:label="$t('ui.full_name')" v-if="optional")
                  DebounceInput(
                    type="text"
                    v-model.trim.lazy="$v.full_name.$model"
                    :disabled="loading"
                    :dirty="$v.full_name.$dirty"
                    :error="$v.full_name.$error"
                  )
                  ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
                b-form-group(:label="$t('ui.mail_address')" v-if="optional")
                  DebounceInput(
                    type="text"
                    v-model="mail_address"
                    :disabled="loading"
                  )

                div.row
                  div.col
                    b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
                div.row
                  div.col.text-right.mt-2
                    SubmitButton.btn-login(icon="fa fa-paper-plane" :text="$t('ui.submit')" variant="secondary" size="lg" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs, alphaNum, helpers, integer, email } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CurrencyLookup from "@/library/CurrencyLookup";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const isValidMYHP = helpers.regex("isValidMYHP", /^(01)[0-46-9]*[0-9]{7,8}$/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CurrencyLookup
  },
  data: function() {
    return {
      account_id: "",
      password: "",
      confirm_password: "",
      affiliate_code: "",
      full_name: "",
      contact_phone: "",
      contact_email: "",
      dob: "",
      mail_address: "",
      currency_code: "MYR",
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/tac",
      optional: false,
    };
  },
  computed: {
  },
  validations: {
    account_id: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20),
      alphaNum
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    },
    affiliate_code: {
      required,
      alphaNum,
      minLength: minLength(3),
      maxLength: maxLength(10)
    },
    full_name: {
      alphaNumWithSpace
    },
    contact_phone: {
      required,
      integer,
      isValidMYHP
    },
    contact_email: {
      email
    },
  },
  mounted: function() {
    this.$refs.account_id.$el.focus();
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    setTacAccountId: function() {
      this.$store.dispatch("user/setTacAccountId", this.account_id);
    },
    submit: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let account_id = this.account_id;
        let password = this.password;
        let affiliate_code = this.affiliate_code;
        let full_name = this.full_name;
        let contact_phone = this.contact_phone;
        let contact_email = this.contact_email;
        let dob = this.dob;
        let mail_address = this.mail_address;
        // let currency_code = this.currency_code;

        this.loading = true;
        this.$store
          .dispatch("user/Signup", {
            account_id,
            password,
            affiliate_code,
            full_name,
            contact_phone,
            contact_email,
            dob,
            mail_address,
            // currency_code
          })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.status;
            if (this.submission.success == true) {
              this.$swal({
                title: this.$t("ui.affiliate_signup"),
                text: this.$t("message.tac_code_has_been_sent"),
                type: "success",
                allowOutsideClick: false
              }).then(isConfirm => {
                if (isConfirm) {
                  this.setTacAccountId();
                  this.$router.push(this.redirect);
                }
              });
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            // this.submission.status =  response.status;
            this.submission.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group-sm > .form-control:not(textarea), .input-group-sm > .custom-select {
  height: calc(1.5em + 0.75rem + 2px) !important;
}

.custom-select-sm {
  height: calc(1.5em + 0.75rem + 2px) !important;
}

.custom-select {
  background-color: rgba(255, 255, 255, 0.3) !important;
  color: white;
}

.invalid {
  font-size: 90% !important;
}

h1 {
  color: #ffffff;
}

p {
  color: rgba(255, 255, 255, 0.5);
}

.card {
  margin-bottom: 0 !important;
  // background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

// .btn-login,
// .btn-login:hover {
//   border: 1px solid rgba(0, 0, 0, 0.75);
//   background: #f29941;
//   background: -moz-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: -webkit-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: linear-gradient(to bottom, #f29941 0%, #e8455d 100%);
//   color: #ffffff;
//   box-shadow: 0 0 16px rgba(255, 255, 255, 0.25);
// }

.input-group-text {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: rgba(0, 255, 255, 0.5);
  padding-right: 1.875rem;
  background-repeat: no-repeat;
  background-position: center right calc(1.875rem / 4);
  background-size: calc(1.875rem / 2) calc(1.875rem / 2);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300ffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

input.is-valid {
  border: 1px solid rgba(0, 255, 255, 0.5);
}

input.is-invalid {
  border: 1px solid rgba(255, 0, 0, 0.5);
}

.switch-slider {
  background: rgba(255, 255, 255, 0.1) !important;
}

::placeholder {
  color: black;
  font-weight: normal;
  opacity: 1;
}
</style>
